/**
 * financeInvoicesApi.js - the Finance Invoice tab's calls to the server
 * (server/routes/financeInvoices.js, /api/finance-invoices). Each answers
 * { ok, status, body } and never throws; body.error says what went wrong.
 */
import { json, send, qs } from '../../utils/api';

export { errorOf } from '../../utils/api';

const BASE = '/api/finance-invoices';

const enc = encodeURIComponent;

export const listInvoices = (params) => json(`${BASE}/invoices${qs(params)}`);
export const getInvoice = (id) => json(`${BASE}/invoices/${enc(id)}`);
export const createInvoice = (inv) => json(`${BASE}/invoices`, send('POST', inv));
export const updateInvoice = (id, patch) => json(`${BASE}/invoices/${enc(id)}`, send('PUT', patch));
export const voidInvoice = (id, reason) => json(`${BASE}/invoices/${enc(id)}/void`, send('POST', { reason }));
export const addPayment = (id, pay) => json(`${BASE}/invoices/${enc(id)}/payments`, send('POST', pay));
export const updatePayment = (id, patch) => json(`${BASE}/payments/${enc(id)}`, send('PUT', patch));
export const deletePayment = (id) => json(`${BASE}/payments/${enc(id)}`, { method: 'DELETE' });
export const listPayments = (from, to) => json(`${BASE}/payments${qs({ from, to })}`);
export const getReceivables = (asOf) => json(`${BASE}/receivables${qs({ as_of: asOf })}`);
export const listProjects = () => json(`${BASE}/projects`);
